module.exports = __webpack_public_path__ + "BrandAssetLibrary_2024_ConsumerBenefit_Slide_4x5.fe28153166be1f1b3c17580f0fe4e768.jpg";